"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.isFeatureEnabled = reselect_1.createSelector(moduleState, function (state) { return function (featureName) {
    var _a;
    return ((_a = state.flags[featureName]) === null || _a === void 0 ? void 0 : _a.value) !== undefined ? state.flags[featureName].value : false;
}; });
exports.getFeatureConfig = reselect_1.createSelector(moduleState, function (state) { return function (featureName) {
    var _a;
    return ((_a = state.flags[featureName]) === null || _a === void 0 ? void 0 : _a.config) !== undefined ? state.flags[featureName].config : null;
}; });
//# sourceMappingURL=selectors.js.map